import * as types from '../types';

const initialState = {
  provider: undefined,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_PROVIDER:
      return {
        ...state,
        provider: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
